import { NotificationActionType } from '~/enums/_types';

const notificationTypeIcons = {
    [NotificationActionType.OrderConfirmed]: 'las la-info-circle',
    [NotificationActionType.OrderInvoice]: 'las la-info-circle',
    [NotificationActionType.OrderReady]: 'las la-info-circle',
    [NotificationActionType.ServiceCallCompleted]: 'las la-info-circle',
    [NotificationActionType.ServiceCallEvidenced]: 'las la-info-circle',
};

export const getIconNameByNotificationType = (notificationType: NotificationActionType): string => {
    return notificationTypeIcons[notificationType];
};
